import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Icon from '../../general/Icon'
import DropDown from '../../button/DropDown'
import { HoverActionValue, StyledHoverAction } from './HoverAction'
import { desktop, mobile } from '../../../styles/media'

const HoverActions = ({ absolute, children, dropdown, mobileReadOnly }) => (
	<StyledHoverActions absolute={absolute} mobileReadOnly={mobileReadOnly}>
		{children}
		{dropdown && (
			<DropDown
				button={(
					<StyledHoverAction>
						<Icon name="dots-horizontal" />
					</StyledHoverAction>
				)}
			>
				{dropdown}
			</DropDown>
		)}
	</StyledHoverActions>
)

HoverActions.propTypes = {
	absolute: PropTypes.bool,
	children: PropTypes.any,
	dropdown: PropTypes.any,
	mobileReadOnly: PropTypes.bool
}

HoverActions.defaultProps = {
	absolute: false,
	children: null,
	dropdown: null,
	mobileReadOnly: false
}

export const StyledHoverActions = styled.div`
	align-items: center;
	display: flex;
	gap: 0.25rem;

	margin-left: 0.5rem;

	${props => props.absolute && `
		position: absolute;
		right: 0;
		top: 50%;
		z-index: 1;

		padding: 0.4rem;

		margin: 0;
		transform: translate(0, -50%);
	`}

	${desktop`
		margin-right: 0.5rem;
	`}

	${mobile`
		${props => props.mobileReadOnly && `
			gap: 0.15rem;
			pointer-events: none;

			${StyledHoverAction} {
				height: 16px;
				min-width: 20px;
				padding: 0 0.25rem;

				svg {
					height: 12px;
					width: 12px;
				}
			}

			${HoverActionValue} {
				font-size: 0.6rem;
			}
		`}
	`}
`

export default HoverActions
